import React from 'react';
import './ContactForm.scss';
import icon from '../../assets/banner/icons/Calling.png';

const ContactForm = () => {
    return (
        <form>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="name">Ad Soyad</label>
                        <input id="name" type="text" className="form-control" placeholder="Adınızı ve soyadınızı girin..." />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="email">E-posta Adresi</label>
                        <input id="email" type="email" className="form-control" placeholder="E-posta adresinizi girin..." />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="service">Hizmet</label>
                        <select id="service" className="form-control" defaultValue="default">
                            <option value="default">Hizmet seçin</option>
                            <option>Diş Beyazlatma</option>
                            <option>İmplant Tedavisi</option>
                            <option>Kanal Tedavisi</option>
                            <option>Protez Uygulamaları</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-group">
                        <label htmlFor="department">Bölüm</label>
                        <select id="department" className="form-control" defaultValue="default">
                            <option value="default">Bölüm seçin</option>
                            <option>Genel Diş Hekimliği</option>
                            <option>Estetik Diş Hekimliği</option>
                            <option>Endodonti</option>
                            <option>İmplantoloji</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="form-group">
                        <label htmlFor="message">Mesajınız</label>
                        <textarea id="message" className="form-control" placeholder='Mesajınızı yazın...' rows="3"></textarea>
                    </div>
                </div>

                <div className="col-lg-6">
                    <button type="submit" className="btn appointment-btn">Randevu Oluştur</button>
                </div>
                <div className="col-lg-6">
                    <div className="appointment-call">
                        <div className='icon'>
                            <img src={icon} alt="icon" />
                        </div>
                        <div className='call-text'>
                            <p>7/24 Acil Diş Desteği</p>
                            <h6>03 482 394 123</h6>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ContactForm;